<template lang="pug">
.central-eventos(v-loading='carregando')
    h3 {{ $t('mensagens.home.centralEventos.titulo') }}

    .lyra__cartao(v-if='eventos.length')
        .central-eventos__evento(
            v-for='evento in eventos',
            :class='evento.visualizado ? "central-eventos__evento--visualizado" : "central-eventos__evento--nao-visualizado"',
            @click='visualizar(evento)'
        )
            .evento__data
                h2 {{ evento.dia }}
                h3 {{ evento.mes }}
            .evento__texto
                p {{ evento.mensagem }}

    .lyra__cartao(v-else)
        .central-eventos__vazio
            h4 {{ $t('mensagens.home.centralEventos.nenhumEventoRecente') }}
</template>

<script>
import CentralEventosService from '@/services/CentralEventosService';

export default {
    name: 'CentralEventos',

    data() {
        return {
            eventos: [],
            carregando: true
        };
    },

    mounted() {
        this.buscarEventos();
    },

    methods: {
        async buscarEventos() {
            this.carregando = true;
            try {
                const { data } = await CentralEventosService.buscarEventos();
                this.eventos = data;
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.home.centralEventos.erro')
                });
            } finally {
                this.carregando = false;
            }
        },

        async visualizar(evento) {
            try {
                if (!evento.visualizado) {
                    await CentralEventosService.visualizar(evento.id);
                    evento.visualizado = true;
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.home.centralEventos.eventoVisualizado'
                        )
                    });
                }
            } catch {
                this.$notify.error({
                    message:
                        'Ocorreu um erro ao marcar o evento como visualizado.'
                });
            }
        }
    },

    watch: {
        '$i18n._vm.locale': function () {
            this.buscarEventos();
        }
    }
};
</script>

<style lang="scss" scoped>
.lyra__cartao {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    padding: 20px;
    overflow: auto;
}

.central-eventos {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    & > h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }
}

.central-eventos__evento {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 6px 7px;
    gap: 13px;
    border-radius: 5px;
    cursor: pointer;

    .evento__data {
        min-width: 40px;
        border-radius: 5px;
        text-align: center;
        padding: 5px;
        color: var(--white);
    }

    .evento__texto {
        display: flex;
        align-items: center;
        color: var(--primary);

        p {
            margin: 0;
        }
    }
}

.central-eventos__evento--visualizado {
    background: #fbfbfb;

    .evento__data {
        background: var(--background-disabled);
    }
}

.central-eventos__evento--nao-visualizado {
    background: var(--color-button-default-hover);

    .evento__data {
        background: var(--secondary);
    }
}

.central-eventos__vazio {
    height: 100%;
    text-align: center;
    display: grid;
    place-items: center;
}
</style>
